import { Component } from '@angular/core';

@Component({
    selector: 'app-metrix-configurator-dynamic',
    templateUrl: './metrix-configurator-dynamic.component.html',
    styleUrls: ['./metrix-configurator-dynamic.component.scss'],
})
export class MetrixConfiguratorDynamicComponent {}
